import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import ListProducts from '@/modules/products/products/listProducts.vue'
import moduleProduct from '@/modules/products/moduleProduct'
import moduleStore from '@/modules/store/moduleStore'
import moduleDesign from '@/modules/store/moduleDesign'
import moduleProfile from '@/modules/profile/moduleProfile'
import moduleDashboard from '@/modules/dashboard/moduleDashboard'
import moduleCadLote from '@/modules/cadlote/cadlote'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Login',
    components: {main: Login}
  },
  {
    path: '/Login',
    name: 'Login',
    components: {main: Login}
  },  
  {
    path: '/Home',
    name: 'Home',
    components: {main: Home},
    meta: {
      requiresAuth: true
    }, 
    children: [
      {
        path: '/Products',
        name: 'Products',
        components: {home: moduleProduct},
        meta: {
          requiresAuth: true
        },            
      },
      {
        path: '/ListProducts',
        name: 'ListProducts',
        components: {home: ListProducts},
        meta: {
          requiresAuth: true
        },            
      },
      {
        path: '/store',
        name: 'Store',
        components: {home: moduleStore},
        meta: {
          requiresAuth: true
        },            
      },
      {
        path: '/design',
        name: 'Design',
        components: {home: moduleDesign},
        meta: {
          requiresAuth: true
        },            
      },    
      {
        path: '/profile',
        name: 'Profile',
        components: {home: moduleProfile},
        meta: {
          requiresAuth: true
        },            
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        components: {home: moduleDashboard},
        meta: {
          requiresAuth: true
        },            
      },       
      {
        path: '/cadlote',
        name: 'CadLote',
        components: {home: moduleCadLote},
        meta: {
          requiresAuth: true
        },            
      } 

    ]   
  },  
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,  
  routes
})

router.beforeEach((to, from, next) => {
  // console.log("Router", to, from)
  if (to.name !== 'Login' && ((localStorage.loggedIn == 'false') || (typeof localStorage.loggedIn == 'undefined'))) next({ name: 'Login' })
  else next()
});
export default router
